import { z } from "zod";
import { FieldOptionsSchema } from "./field.js";
export { FieldOptionsSchema };
import { checkbox } from "./checkbox.js";
import { checkboxGroup } from "./checkboxGroup.js";
import { dropdownMulti } from "./dropdownMulti.js";
import { datePicker } from "./datePicker.js";
import { dateTimePicker } from "./dateTimePicker.js";
import { dropdownSingle } from "./dropdownSingle.js";
import { multilineText } from "./multilineText.js";
import { number } from "./number.js";
import { radioGroup } from "./radioGroup.js";
import { singleLineText } from "./singleLineText.js";
import { toggleSwitch } from "./toggleSwitch.js";
// A field on a module, as the builder holds it and the database stores it: one
// member per control. This tuple is where `FormControlKey` comes from, and
// everything below is held to it.
export const ModuleFieldSchema = z.discriminatedUnion("control", [
    singleLineText.schema,
    multilineText.schema,
    number.schema,
    checkbox.schema,
    dropdownSingle.schema,
    dropdownMulti.schema,
    radioGroup.schema,
    checkboxGroup.schema,
    datePicker.schema,
    dateTimePicker.schema,
    toggleSwitch.schema,
]);
/**
 * Every control, in the order the field library offers them. `satisfies`
 * holds this to the union in both directions: a control in the union without
 * a definition, or a definition without a member in the union, does not
 * compile.
 *
 * A registry in code rather than reference data, because every control needs
 * something that draws it. Entity links are named in reference data, and what
 * each means for a module's answers is a code registry too (ENTITY_LINKS).
 */
export const CONTROLS = {
    singleLineText,
    multilineText,
    number,
    checkbox,
    dropdownSingle,
    dropdownMulti,
    radioGroup,
    checkboxGroup,
    datePicker,
    dateTimePicker,
    toggleSwitch,
};
/** What the field library offers, in order. */
export const FORM_CONTROLS = Object.values(CONTROLS).map(({ key, label }) => ({ key, label }));
/** The control's own name, which a new field of it is given. */
export const controlLabel = (key) => CONTROLS[key].label;
